export default {
    props: {
        validationAllowedExtensions: {
            type: Array,
            default: undefined,
            kComposite: 'validation.allowedExtensions'
        }, 
        validationMaxFileSize: {
            type: Number,
            default: undefined,
            kComposite: 'validation.maxFileSize'
        }, 
        validationMinFileSize: {
            type: Number,
            default: undefined,
            kComposite: 'validation.minFileSize'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-upload-vue-wrapper/src/KendoUpload/Validation.js